<template>
  <div class="tool-item" @click.self="$emit('toDetail', toolObj.id, toolObj.typeId)">
    <!-- <img :src="toolObj.iconFileUri || testIconSrc" :alt="toolObj.toolName" class="tool-icon" @click="$emit('toDetail', toolObj.id, toolObj.typeId)" /> -->
    <div class="info">
        <p @click="$emit('toDetail', toolObj.id, toolObj.typeId)" class="tool-name" :title="toolObj.toolName">{{ toolObj.toolName || "" }}</p>
        <div class="flex-box">
            <p class="created-time">{{ toolObj.createData ? new Date(toolObj.createData).format("yyyy-MM-dd hh:mm") : "" }}</p>
            <a-button type="link" href="javascript:void(0);" class="download-btn" @click="$emit('verify', toolObj.downloadUri)">下载</a-button>
        </div>
    </div>
  </div>
</template>
<script>
import { downloadTool } from "../../../api/tools";
export default {
  name: "tool-item",
  props: {
    toolObj: {
      type: Object,
    },
  },
  data() {
    return {
      testIconSrc: require("../../../assets/imgs/icon2.png"),
    };
  },
  methods: {
    downLoad(url) {
      console.log(url);
      downloadTool(url).then(res => {
        if(res && res.data) {
          console.log("下载", res.data);
          window.location.href = res.data;
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../../styles/utils.scss';
.tool-item {
  width: 324px;
  height: 141px;
  display: inline-block;
  margin: 12px 10px;
  padding: 24px 15px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
}
.flex-box {
    display: flex;
    align-items: center;
}
.tool-item:hover {
    border: 1px solid #1890FF;
}
.tool-icon {
  display: inline-block;
  width: 72px;
  height: 72px;
  margin-right: 20px;
}
.info {
  width: 200px;
    display: inline-block;
    vertical-align: top;
}
.tool-name {
  margin: 0;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0.6px;
  @include ellipsis(2)
}
.created-time {
  margin: 4px 0 6px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0.45px;
}
.download-btn .ant-btn{
  padding: 0;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 18px;
  color: #007AFF;
  letter-spacing: 0.55px;
}
</style>